export default {
	form: {
		required_error: 'この項目は必須です',
		max_length_exceeded_error:
			'文字数が上限を超えています（最大{{length}}文字）'
	},
	legal: {
		copyright: 'Gerositus Sàrl - 無断転載を禁じます',
		i_consent: '同意する',
		agreement_title: '同意事項',
		agreement_content:
			'Gerositusをご利用いただくことで、<1>利用規約</1>および<2>プライバシーポリシー</2>に同意したことになります。',
		agreement_terms_conditions: '利用規約',
		agreement_privacy_policy: 'プライバシーポリシー',
	},
	navigation: {
		home: 'ホーム'
	},
	yes: 'はい',
	no: 'いいえ',
	not_defined: '未定義',
	please_wait: 'お待ちください',
	search: '検索',
	upgrade_required: 'アップグレードが必要です',
	create_project_title: '何を達成したいですか？',
	click_to_change: 'クリックして変更',
	click_to_create_one: '<button>新規作成</button>してください',
	no_goal: '目標なし',

	auth: {
		token_expiring_soon: 'セッションはあと{{minutes}}分で期限切れになります',
		token_expired:
			'セッションの有効期限が切れました。ログインページに移動します。',
		token_check_error: 'トークンの確認中にエラーが発生しました',
		session_expiring:
			'セッションがまもなく終了します。再接続してください。残り時間：{{time}}'
	},
	bot: {
		placeholder: 'ここに質問を入力',
		security_notice: 'プライベートかつ隔離されたAI。やり取りは機密に保たれます。'
	},
	tutorial: {
		button: 'チュートリアル',
		exit_title: 'チュートリアルを終了',
		exit_confirm: 'チュートリアルを終了してもよろしいですか？'
	},
	subscription: {
		billing_monthly: '月額',
		billing_yearly: '年額',
		billing_yearly_save: '（20%お得）',
		choose_now: '今すぐ選択'
	},
	icons: {
		used: '使用中',
		unused: '未使用'
	},
	theme: {
		selector: 'テーマ選択',
		current_theme: '現在のテーマ',
		change_theme: 'テーマを変更'
	},
	no_description: '説明なし',
	situation_analysis: {
		title: '状況分析',
		description: '組織・企業・状況を自動で分析します',
		organization_label: '組織 / 企業',
		organization_placeholder: '分析する組織名',
		subject_label: 'テーマ',
		subject_placeholder: '分析するテーマ（プロジェクト名で事前入力）',
		launch_analysis: '分析を実行',
		analysis_in_progress: '分析中…',
		complete_analysis: '分析を完了',
		waiting_analysis: '分析の結果を待っています…',
		waiting_summary: '要約を待っています…',
		waiting_stakes: 'ステークを待っています…',
		waiting_risks: 'リスクを待っています…',
		waiting_openings: '突破口を待っています…',
		waiting_stakeholders: 'ステークホルダーを待っています…',
		context_title: '全体の文脈',
		summary_title: '要約',
		stakes_title: 'ステーク',
		risks_title: 'リスク',
		openings_title: '突破口',
		stakeholders_title: 'ステークホルダー',
		status: '状態',
		likelihood: '発生可能性',
		impact: '影響',
		stakeholder: {
			importance_label: '相対的重要度',
			propensity_label: '傾向',
			engagement_label: 'エンゲージメント',
			importance_values: {
				low: '低',
				medium: '中',
				high: '高'
			},
			propensity_values: {
				green: '協力的',
				neutral: '中立',
				orange: '緊張',
				red: '対立'
			},
			engagement_values: {
				inactive: '非活動',
				neutral: '中立',
				low: '低',
				medium: '中',
				high: '高'
			},
			polarity_values: {
				positive: '支持',
				negative: '反対'
			}
		},
		risk_category_values: {
			operational: 'オペレーション',
			strategic: '戦略',
			existential: '存続'
		}
	},
	ai_project_generation: {
		checkbox_label: 'AIでコンテンツを生成',
		checkbox_tooltip:
			"タイトル、ミッション、説明、下に記載のシナリオを使用します。公開AI検索は「プロジェクトを作成」を押した後にのみ開始されます。",
		title: 'AIプロジェクト生成',
		go_to_project: 'プロジェクトへ',
		create_project: 'プロジェクトを作成',
		include_in_project_aria: 'プロジェクトにこの項目を含める',
		creation_modal_title: '項目を作成しています',
		creation_progress_text: '{{current}} / {{total}} 件作成済み',
		error_title: '生成エラー',
		complete_title: '生成が完了しました',
		complete_description:
			'プロジェクトが正常に充実しました。主要なステークホルダー、ステーク、リスク、突破口をAIが特定しました。',
		summary_title: '分析サマリー',
		initializing_text: '詳細分析の準備中です。6〜10分かかる場合があります。',
		include_in_project_tooltip:
			'オンにすると、「プロジェクトを作成」を押したときにこの項目がプロジェクトに追加されます。',
		language_code: 'ja',
		patience_with_scenarios:
			'シナリオ生成は複雑なため、数分かかる場合があります。ご辛抱ありがとうございます。',
		patience_no_scenarios:
			'詳細な分析には数分かかる場合があります。ご辛抱ありがとうございます。',
		phases: {
			initializing: '起動',
			deep_research: '調査',
			analyzing: 'AI分析',
			stakeholders: 'ステークホルダー',
			stakes: 'ステーク',
			risks: 'リスク',
			openings: '突破口',
			summary: '要約',
			fishbone: 'アクションプラン',
			entities: 'エンティティ',
			scenarios: 'シナリオ',
			completed: '完了',
			error: 'エラー'
			},
		section_title: "AI生成の詳細",
		disclosure_public_title: "公開AIへ",
		disclosure_public_sub: "Web検索。下記の中立的なプレビューのみを受信します — 意図や目的は伝えません。",
		disclosure_private_title: "プライベートで分離されたAI",
		disclosure_private_sub: "分離された環境で実行されます。再学習なし、外部への情報送信なし。タイトル、ミッション、説明、シナリオを処理します。",
		zone_public: "公開AIへ送信",
		zone_private: "プライベート — 公開AIへ送信されません",
		field_private_chip: "プライベートで安全",
		field_private_tooltip: "分離された環境のプライベートAIで処理されます。再学習なし、外部への情報送信なし。",
		preview_title: "検索プレビュー",
		preview_refresh: "プレビューを再生成",
		preview_hint: "主題の中立的な再表現 — 意図の痕跡なし。公開検索に送信される内容そのものです — 確認後にのみ送信されます。",
		preview_placeholder: "プレビューを生成するには、少なくともプロジェクトのタイトルを入力してください。",
		launch_generation: "生成を開始",
		fishbone_source: 'ソーステキスト',
		scenario_n: 'シナリオ {{n}}',
		scenario_optimistic: '楽観的',
		scenario_baseline: '最も可能性が高い',
		scenario_pessimistic: '悲観的',
		scenario_pending: '保留中',
		scenario_triggers: 'トリガーイベント',
		scenario_action_window: 'アクションの猶予',
		scenario_detail: '詳細分析',
		dismiss: 'AI提案を破棄してプロジェクトを作成',
		save_pdf: 'PDFとして保存',
		save_hint: 'プロジェクトに入る前に、この分析を保存できます。',
		scenario_impacts: 'エンティティへの影響',
		data: {
			scenarios: '将来シナリオ',
			fishbone: '戦略アクションプラン'
		}
	},
	scenario_elaboration: {
		title: 'AIシナリオの詳細化',
		hypothesis: '仮説',
		initializing: '分析を初期化しています…',
		error_title: '詳細化エラー',
		complete_title: '詳細化が完了しました',
		complete_description:
			'シナリオの詳細化が完了し、変更が反映されました。',
		analysis_preview: '予備分析',
		applied_changes: '適用された変更',
		stakeholders_modified: '件のステークホルダーが変更されました',
		stakes_modified: '件のステークが変更されました',
		risks_modified: '件のリスク／突破口が変更されました',
		indicators_modified: '件の指標が変更されました',
		new_elements: '新規',
		steps: {
			started: '開始',
			started_desc: '分析を初期化しています…',
			fetching_project: 'プロジェクト取得',
			fetching_project_desc: 'プロジェクトデータを読み込み中…',
			deep_research: '初期分析',
			deep_research_desc: '状況の深い分析…',
			ai_analysis: 'AI分析',
			ai_analysis_desc: '仮説の影響をAIが分析しています…',
			reformatting: '整形',
			reformatting_desc: '結果を構造化しています…',
			processing_stakeholders: 'ステークホルダー',
			processing_stakeholders_desc: 'ステークホルダーへの影響を算出中…',
			processing_stakes: 'ステーク',
			processing_stakes_desc: 'ステークへの影響を算出中…',
			processing_risks: 'リスク',
			processing_risks_desc: 'リスクへの影響を算出中…',
			processing_indicators: '指標',
			processing_indicators_desc: '指標への影響を算出中…',
			completed: '完了',
			completed_desc: '分析が正常に完了しました',
			error: 'エラー',
			error_desc: 'エラーが発生しました'
		}
	}
};
